/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_traffic_info_settings__header = /** @type {(inputs: {}) => string} */ () => {
	return `VERKEHRSBEDINGUNGEN`
};

const en_traffic_info_settings__header = /** @type {(inputs: {}) => string} */ () => {
	return `TRAFFIC CONDITIONS`
};

const es_traffic_info_settings__header = /** @type {(inputs: {}) => string} */ () => {
	return `ESTADO DEL TRÁFICO`
};

const fr_traffic_info_settings__header = /** @type {(inputs: {}) => string} */ () => {
	return `ÉTAT DU TRAFIC`
};

const it_traffic_info_settings__header = /** @type {(inputs: {}) => string} */ () => {
	return `STATO DEL TRAFFICO`
};

const nl_traffic_info_settings__header = /** @type {(inputs: {}) => string} */ () => {
	return `VERKEERSSITUATIE`
};

const pt_traffic_info_settings__header = /** @type {(inputs: {}) => string} */ () => {
	return `CONDIÇÕES DE TRÁFEGO`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const traffic_info_settings__header = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.traffic_info_settings__header(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("traffic_info_settings__header", locale)
	if (locale === "de") return de_traffic_info_settings__header(inputs)
	if (locale === "en") return en_traffic_info_settings__header(inputs)
	if (locale === "es") return es_traffic_info_settings__header(inputs)
	if (locale === "fr") return fr_traffic_info_settings__header(inputs)
	if (locale === "it") return it_traffic_info_settings__header(inputs)
	if (locale === "nl") return nl_traffic_info_settings__header(inputs)
	return pt_traffic_info_settings__header(inputs)
};